export default __webpack_public_path__ + "static/media/LionFiction.0add308f.png";